import { atom } from 'recoil';

export const customColors = atom({
    key: 'customColors',
    default: {
        PRIMARY: "#0030a8",
        BLUEMONEDD: "#0030a8",
        BLUEMONEDDRGB: "rgba(0,48,168,0.80)",
        BLUEMONEDDRGB2: "rgba(0,48,168,1)",
        BLUEMONEDDBUTTONS: "#1C3E92",
        BLUEMONEDDBACKGROUND: "#0B2760",
        BLUEMONEDDINFOMODAL: "#3A67C1",
        YELLOWMONEDD: "#ffee25",
        YELLOWMONEDDRGB: "rgba(255,238,37,0.55)",
        ORANGEMONEDD: "#ee8233",
        ORANGEMONEDDRGB: "rgba(238,130,51,0.65)",
        REDMONEDD: "#8E1414",
        REDMONEDDRGB: "rgba(170,49,45,0.55)",
        VARIANT: "#0078d4",
        SECONDARY: "#ffc107",
        SUCCESS: "#28a745",
        DANGER: "#dc3545",
        WARNING: "#ffc107",
        INFO: "#17a2b8",
        LIGHT: "#f8f9fa",
        DARK: "#343a40",
        WHITE: "#fff",
        BLACK: "#000",
        GRAY: "#6c757d",
        GRAY_LIGHT: "#f8f9fa",
        GRAY_DARK: "#343a40",
        GRAY_LIGHTER: "#e9ecef",
        GRAY_DARKER: "#adb5bd",
        GRAY_LIGHTEST: "#f5f6f7",
        GRAY_DARKEST: "#343a40",
        GRAY_NEUTRAL: "#6c757d",
        GRAY_NEUTRAL_LIGHT: "#e9ecef",
        GRAY_NEUTRAL_DARK: "#adb5bd",
        GRAY_NEUTRAL_LIGHTEST: "#f5f6f7",
        GREENMONEDD: "#4A783C",
        GREENCARD: "#09A40F",
        BLUECARD: "#1C3E92",
        REDCARD: "#D71010",
        GRAYCARD: "#E1E1E1",
        ICECARD: "#ECECEC",
        LOGO: "./logoBranca.png",
        BACKGROUND: "",
    },
});